module.exports = __webpack_public_path__ + "48456bd7653807c86670a756889e6c40.jpg";